/** @jsxImportSource @emotion/react */
import * as React from 'react';
import { css, SerializedStyles } from '@emotion/react';
import { BLACK, RED_CREEK } from '../../styles/colors';
import { TinyText } from '../../styles/styles';
import { getResource } from '../../language/resources/getResource';

/**
 * CharacterCount: a component that accepts a string and shows the number of characters in that string. Offers a number
 * of nice features like showing red for numbers outside a given set of bounds, and string trimming before counting.
 * Useful in forms that need to accept free-form text from the user, but need to control the number of characters in
 * that free-form text.
 *
 * PureComponent: true
 * Connected to Redux: false
 */
export default class CharacterCount extends React.PureComponent<{
  rootCss?: SerializedStyles;
  valueToCount: string;
  /**
   * The minimum number of characters required. Inclusive.
   */
  minRequired: number;
  /**
   * The maximum number of characters allowed. Inclusive.
   */
  maxAllowed: number;
  /**
   * Whether or not to trim the ends of the input string before counting its characters.
   */
  trimStr?: boolean;
  resources: Record<string, any>;
}> {
  public static defaultProps = {
    trimStr: true,
  };

  public render = () => {
    const value      = this.props.trimStr ? this.props.valueToCount.trim() : this.props.valueToCount;
    const length     = value.length;
    const isValidLen = length >= this.props.minRequired && length <= this.props.maxAllowed;

    return (
      <span css={css`${TinyText}; ${this.props.rootCss};`}>
        {getResource(this.props.resources, 'CHARACTER_COUNT_CHARACTERS')}&nbsp;
        <span css={css`
                          ${TinyText};
                          color: ${isValidLen ? BLACK : RED_CREEK};
                        `}>{length}</span>
      </span>
    );
  };
}
